<template>
  <div>
    <!-- header section -->
    <div class="flex flex-row px-4 justify-between h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center text-sm font-semibold text-grey-darkest">Health Coach</div>
      <img class="w-3 cursor-pointer" src='../../assets/close.svg' v-show="showTests" @click="showTests = false"/>
    </div>

    <div v-if="!showTests">
      <!-- prgoramm details -->
      <div class="bg-white flex flex-col p-4 text-sm text-grey-darkest font-semibold">
        <div class="flex flex-row items-center justify-between">
          <p class="capitalize">{{timelineAndProgress.program_name}}</p>
          <p class="px-3 py-1 bg-yellow-lighter rounded-full capitalize">{{programDetails.currentWeek}}</p>
        </div>
        <div>
          <p class="text-xs">{{`Duration: ${timelineAndProgress.program_duration}`}}</p>
        </div>
      </div>
      <!--  GOALS SECTION  -->
      <div style="height: calc(100vh - 8rem);" :class="selectWeek ? 'overflow-hidden' : 'overflow-y-scroll'">
        <div class="p-4 mt-4 bg-white text-sm">
          <div class="flex flex-row items-center justify-between font-semibold border-b border-dashed pb-2">
            <p class="text-grey-darkest font-semibold">Goals</p>
            <p v-show="!editGoal.edit" class="text-blue cursor-pointer" @click="editGoal.edit ? '' : editGoal.edit = true"> Edit </p>
            <div v-show="editGoal.edit" class="flex flex-row justify-between">
              <p class="text-red-dark cursor-pointer" @click="editGoal.edit ? editGoal.edit = false : editGoal.edit = true"> Cancel </p>
              <p class="text-blue pl-4 cursor-pointer" @click="saveGoal"> Save </p>
            </div>
          </div>
          <div>
            <div v-for="goal in goals" :key="goal.id" class="pt-4 flex flex-row justify-between text-grey-darkest">
              <p class="w-1/2 capitalize">{{ goal.display_name }}</p>
              <div class="w-1/2">
                <div class="flex flex-row justify-end">
                  <p v-show="!editGoal.edit" class="font-semibold">{{ goal.target_value }} {{goal.units && goal.units.trim() !== '' && goal.units.trim() !== 'nil' ? goal.units : '' }}</p>
                  <div v-show="editGoal.edit" class="flex flex-row justify-end items-center font-semibold w-32 text-left border rounded">
                    <input
                      :ref="goal.name"
                      v-model="goal.target_value"
                      class="bg-grey-extralight p-2 focus:bg-grey-extralight w-1/2 text-left"
                    />
                    <span class="text-grey p-2 text-right bg-grey-extralight w-1/2 flex-shrink-0">
                      {{ goal.units && goal.units.trim() !== '' && goal.units.trim() !== 'nil' ? goal.units : 'N/A' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  VITALS SECTION  -->
        <div class="p-4 mt-4 bg-white text-sm">
          <div class="flex flex-col justify-between">
            <div class="flex flex-row items-center justify-between text-grey-darkest font-semibold border-b border-dashed pb-2">
              <div class="flex flex-row items-center justify-between w-full">
                <div class="flex flex-row items-center">
                  <p class="mr-2 text-grey-darkest font-semibold">Vitals</p>
                  <div>
                    <div @click="vitals.length > 1 ? selectWeek = !selectWeek : ''" class="rounded border bg-grey-extralight p-2 flex flex-row items-center cursor-pointer">
                      <div class="mr-2">Week {{currentWeek}}</div>
                      <img src="../../assets/down-arrow-full.svg" />
                    </div>
                    <div v-show="vitals.length > 0" v-if="selectWeek" class="absolute mt-8 w-48 z-20 max-h-36 border bg-white font-semibold text-grey-dark overflow-y-scroll">
                      <p v-for="week in uniqueWeeks" :key="week" @click="changeWeek(week)" class="cursor-pointer py-4 pl-12 hover:bg-blue-extralight">Week {{week}}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <button class="text-blue cursor-pointer" @click="openInsights()"> View Insights</button>
                </div>
              </div>
            </div>
            <div v-for="vital in currentVitals" :key="vital.units" class="pt-5 flex flex-row justify-between text-grey-darkest">
              <p class="capitalize">{{vital.display_name}}</p>
              <p class="font-semibold">{{vital.current_value}} {{ vital.units && vital.units.trim() !== '' && vital.units.trim() !== "nil" ? vital.units : '' }}</p>
            </div>
          </div>
        </div>
        <!-- PROGRESS TIMELINE -->
        <div class="w-full mt-4 px-4 py-5 text-grey-darker bg-white text-sm">
          <p class="text-grey-darkest font-semibold border-b border-dashed pb-4">Progress</p>
          <div v-for="(activities, week) in timelineAndProgress.activities" :key="week" class="flex flex-col py-4 border-b">
            <div class="mb-2 font-semibold text-grey-dark">Week {{ week }}</div>

            <div
              v-for="(activity, index) in activities"
              :key="index"
              class="relative"
            >
              <div class="flex flex-row items-end pt-6" :class="{ 'mt-0': index === 0 }">
                <img
                  :src="getIcon(activity.status)"
                  class="bg-grey-extralight h-6 w-6 p-1 rounded-full mr-3"
                  style="z-index: 2"
                />
                <div class="flex flex-row justify-between w-full">
                  <div>
                    <p class="text-grey-darkest font-semibold">{{ activity.title }}</p>
                    <p v-if="summaryData[activity.activity_id]" class="text-grey-dark mt-1">
                      {{ summaryData[activity.activity_id] }}
                    </p>
                    <p v-else class="text-grey mt-1 capitalize">{{ activity.subtitle }}</p>
                    <ul v-if="activity.activity_type === 'challenge'" class="mt-1">
                      <li class="text-grey">Challenge progress: 50%</li>
                      <li class="text-grey">Days Taken: 5 consecutive days</li>
                    </ul>
                  </div>

                  <div v-if="activity.cta_text" class="ml-4">
                    <div class="text-blue font-semibold cursor-pointer" @click="getActivityDetails(activity)">{{ activity.cta_text }}</div>
                  </div>
                </div>
              </div>

              <!-- Vertical dashed line -->
              <div
                v-if="index !== activities.length - 1"
                class="absolute w-px border-l-2 border-grey-lightest border-dashed"
                style="left: 11px; height: 30px;"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showTests">
      <patient-tests :showTests="showTests" :data="reportsData" @close="showTests = false" />
    </div>

    <!-- Drawer section -->
    <div>
      <div
        class="right-drawer"
        :style="{
          width: drawerVisible ? '35vw' : '0'
        }"
      >
        <div class="flex flex-row justify-between border-b p-4">
          <h3>Insights</h3>
          <button class="close" @click="drawerVisible = false">
            <img class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
          </button>
        </div>
        <div class="flex flex-row m-4 justify-start">
          <button v-for="(label, key) in chartTypes" :key="key" :class="['bg-transparent hover:bg-blue text-grey hover:text-white border hover:border-transparent rounded-lg px-2 py-2', { 'border-blue text-blue': selectedChart === key, 'ml-4': key !== 'weight' }]" @click="selectedChart = key">
            {{ label }}
          </button>
        </div>
        <div class="p-4 border-b" v-if="selectedChart === 'weight'">
          <h3>Weight <span class="text-grey" style="font-weight: 400"> (kgs) </span> </h3>
          <p class="text-grey text-sm mt-2">Last updated: <span> {{ lastUpdateAt('weight') }} </span></p>
          <VueApexCharts v-if="weightSeriesData[0].data.length" type="line" height="200" :options="weightChartOptions" :series="weightSeriesData" />
          <div v-else class="text-grey text-sm mt-4">No data available for Weight</div>
        </div>
        <div class="p-4 border-b" v-else-if="selectedChart === 'bloodSugar'">
          <h3>Blood Sugar <span class="text-grey" style="font-weight: 400"> (mg/dL) </span> </h3>
          <p class="text-grey text-sm mt-2">Last updated: <span> {{ lastUpdateAt('blood_sugar') }} </span></p>
          <VueApexCharts v-if="bloodSugarSeriesData[0].data.length" type="line" height="200" :options="bloodSugarChartOptions" :series="bloodSugarSeriesData" />
          <div v-else class="text-grey text-sm mt-4">No data available for Blood Sugar</div>
        </div>
        <div class="p-4 border-b"  v-else-if="selectedChart === 'bloodPressure'">
          <h3>Blood Pressure <span class="text-grey" style="font-weight: 400"> (mmHg) </span> </h3>
          <p class="text-grey text-sm mt-2">Last updated: <span> {{ lastUpdateAt('blood_pressure') }} </span></p>
          <VueApexCharts v-if="bloodPressureSeriesData[0].data.length && bloodPressureSeriesData[1].data.length" type="line" height="200" :options="bloodPressureChartOptions" :series="bloodPressureSeriesData" />
          <div v-else class="text-grey text-sm mt-4">No data available for Blood Pressure</div>
        </div>
        <div class="p-4 border-b"  v-else-if="selectedChart === 'HbA1c'">
          <h3>HbA1c <span class="text-grey" style="font-weight: 400"> (%) </span> </h3>
          <p class="text-grey text-sm mt-2">Last updated: <span> {{ lastUpdateAt('hba1c') }} </span></p>
          <VueApexCharts v-if="hba1cSeriesData[0].data.length" type="line" height="200" :options="hba1cChartOptions" :series="hba1cSeriesData" />
          <div v-else class="text-grey text-sm mt-4">No data available for HbA1c</div>
        </div>
        <div class="mb-10 p-4">
          <div class="flex flex-row justify-between items-center w-full">
            <div>
              <h3>Steps Graph</h3>
              <p class="text-grey text-sm mt-2">Last updated: <span> {{ stepsLastUpdateAt(stepsUnit) }} </span></p>
            </div>
            <div class="flex flex-row justify-between">
              <div className="flex items-center rounded-lg">
                <div class="relative z-10 flex items-center rounded-lg border border-stroke bg-grey-lightest p-1">
                  <button class="inline-flex h-6 items-center justify-center rounded px-3 text-sm font-medium duration-200 hover:bg-white hover:text-black g-grey-lightest text-grey-light transition-all duration-300 ease-in-out"  @click="stepsUnit = 'day'":class="{ 'bg-white text-black scale-105': stepsUnit === 'day' }">Day</button>
                  <button class="inline-flex h-6 items-center justify-center rounded px-3 text-sm font-medium duration-200 hover:bg-white hover:text-black ml-2 bg-grey-lightest text-grey-light transition-all duration-300 ease-in-out"  @click="stepsUnit = 'week'" :class="{ 'bg-white text-black scale-105': stepsUnit === 'week' }">week</button>
                </div>
              </div>
            </div>
          </div>
          <div class="max-h-[320px] overflow-auto pr-2">
            <div v-if="stepsUnit === 'week'">
              <VueApexCharts v-if="dailyStepsSeriesData[0].data.length" type="bar" height="300" :width="chartWidth" :options="weeklyStepsChartOptions" :series="weeklyStepsSeriesData" />
              <div v-else class="text-grey text-sm mt-4">No daily step data available</div>
            </div>
            <div v-else-if="stepsUnit === 'day'">
              <VueApexCharts v-if="weeklyStepsSeriesData[0].data.length" type="bar" height="300" :width="chartWidth" :options="dailyStepsChartOptions" :series="dailyStepsSeriesData" />
              <div v-else class="text-grey text-sm mt-4">No weekly step data available</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="drawer-mask"
        :style="{
          width: drawerVisible ? '100vw' : '0',
          opacity: drawerVisible ? '0.6' : '0',
        }"
        @click="drawerVisible = false"
      ></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import HealthCoachProgress from './HealthCoachProgress.vue'
import PatientHra from './PatientHra.vue'
import healthCoach from '../../api/health_coach'
import customerAPI from '../../api/customer/general'
import hraMixin from '../mixins/hra_mixin'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import PatientTests from './PatientTests.vue'

Vue.use(VueToast)
export default {
  mixins: [hraMixin],
  components: {
    HealthCoachProgress,
    PatientHra,
    PatientTests,
    VueApexCharts
  },
  data () {
    return {
      selectWeek: false,
      editGoal: {edit: false, name: '', prevValue: ''},
      programEnrollmentId: null,
      drawerVisible: false,
      selectedChart: 'weight',
      stepsUnit: 'day',
      showTests: false,
      reportsData: {},
      summaryData: {},
      chartTypes: {
        weight: 'Weight',
        bloodSugar: 'Blood Sugar',
        bloodPressure: 'Blood Pressure',
        HbA1c: 'HbA1c'
      }
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      programDetails: 'healthCoach/getProgramDetails',
      goals: 'healthCoach/getCurrentGoals',
      vitals: 'healthCoach/getVitals',
      progress: 'healthCoach/getProgress',
      currentWeek: 'healthCoach/getVitalsWeek',
      dailyStepsData: 'healthCoach/getDailySteps',
      weeklyStepsData: 'healthCoach/getWeeklySteps',
      timelineAndProgress: 'healthCoach/getTimelineAndProgress'
    }),
    currentVitals: function () {
      return this.vitals.filter((ele) => ele.week.toString() === this.currentWeek.toString())
    },
    goalsList: function () {
      return this.addGoals
    },
    uniqueWeeks: function () {
      const weeks = this.vitals.map(v => v.week)
      return [...new Set(weeks)]
    },
    weightChartOptions: function () {
      return {
        chart: {
          id: 'weight-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('weight').map(v => this.formatDate(v.created_at))
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      }
    },
    weightSeriesData: function () {
      return [
        {
          name: 'Weight',
          data: this.getVitalsByName('weight').map(v => v.current_value)
        }
      ]
    },
    bloodSugarChartOptions: function () {
      return {
        chart: {
          id: 'blood-sugar-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('blood_sugar').map(v => this.formatDate(v.created_at))
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      }
    },
    bloodSugarSeriesData: function () {
      return [
        {
          name: 'Blood Sugar',
          data: this.getVitalsByName('blood_sugar').map(v => v.current_value)
        }
      ]
    },
    bloodPressureChartOptions: function () {
      return {
        chart: {
          id: 'blood-pressure-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('blood_pressure').map(v => this.formatDate(v.created_at))
        },
        stroke: {
          width: 3,
          colors: ['#2168F3', '#FF6969']
        },
        markers: {
          size: 4,
          colors: ['#2168F3', '#FF6969']
        },
        legend: {
          labels: {
            colors: ['#2168F3', '#FF6969'],
            useSeriesColors: false
          },
          markers: {
            fillColors: ['#2168F3', '#FF6969']
          }
        }
      }
    },
    bloodPressureSeriesData: function () {
      return [
        {
          name: 'systolic',
          data: this.systolicBloodPressure()
        },
        {
          name: 'diastolic',
          data: this.diastolicBloodPressure()
        }
      ]
    },
    hba1cChartOptions: function () {
      return {
        chart: {
          id: 'hba1c-chart',
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.getVitalsByName('hba1c').map(v => this.formatDate(v.created_at))
        },
        stroke: {
          width: 3,
          colors: ['#2168F3']
        },
        markers: {
          size: 4,
          colors: ['#2168F3']
        }
      }
    },
    hba1cSeriesData: function () {
      return [
        {
          name: 'HbA1c',
          data: this.getVitalsByName('hba1c').map(v => v.current_value)
        }
      ]
    },
    dailyStepsChartOptions: function () {
      return {
        chart: {
          id: 'steps-chart',
          toolbar: {
            show: false
          },
          width: 1200
        },
        xaxis: {
          categories: this.dailyStepsData.map(v => this.formatDate(v.date))
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%'
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    dailyStepsSeriesData: function () {
      return [
        {
          name: 'Steps',
          data: this.dailyStepsData.map(v => v.count)
        }
      ]
    },
    weeklyStepsChartOptions: function () {
      return {
        chart: {
          id: 'steps-chart',
          toolbar: {
            show: false
          },
          width: 1200
        },
        xaxis: {
          categories: this.weeklyStepsData.map(v => v.week)
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%'
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    weeklyStepsSeriesData: function () {
      return [
        {
          name: 'Steps',
          data: this.weeklyStepsData.map(v => v.count)
        }
      ]
    },
    chartWidth: function () {
      const baseWidth = 30
      const padding = 50

      const data =
        this.stepsUnit === 'week'
          ? this.weeklyStepsSeriesData[0].data || []
          : this.dailyStepsSeriesData[0].data || []
      const finalWidth = data.length * baseWidth + padding

      if (finalWidth < 400) {
        return 400
      } else if (finalWidth > 1200) {
        return 1200
      } else {
        return finalWidth
      }
    }
  },
  watch: {
    goals: function (newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.prevGoals = [...this.goals]
      }
    },
    customer: function (newVal, oldVal) {
      if (newVal.customerId !== oldVal.customerId) {
        this.getHealthCoachDetails()
      }
    }
  },
  mounted () {
    this.getHealthCoachDetails()
  },
  methods: {
    getHealthCoachDetails () {
      healthCoach.getHealthCoachDetails(this.customer.customerId).then(
        response => {
          this.$store.dispatch('healthCoach/healthCoachInitialState', {data: response.data})
          this.programEnrollmentId = response.data.program_enrollment_id
          this.getCustomerGoalVitals()
          this.getDailyCustomerSteps()
          this.getWeeklyCustomerSteps()
          this.getTimelineAndProgress()
        }
      ).catch((err) => {
        this.progress = []
        if (err.status === 404) {
          this.$toast.open({
            message: 'Not enrolled in a program',
            type: 'warning',
            position: 'top',
            queue: false
          })
        } else if (err.status === 500) {
          this.$toast.open({
            message: 'Error fetching health coach details',
            type: 'error',
            position: 'top',
            queue: false
          })
        }
      })
      this.prevGoals = [...this.goals]
    },
    getCustomerGoalVitals () {
      healthCoach.getCustomerGoalVitals(this.programEnrollmentId, this.customer.customerId).then(
        response => {
          this.$store.dispatch('healthCoach/setCustomerVitals', {data: response.data})
        }
      )
    },
    saveGoal: function () {
      let val = this.goals
      let programEnrollmentId = this.programEnrollmentId

      this.$store.dispatch('healthCoach/updateGoal', { programEnrollmentId, val })
        .then(() => {
          this.editGoal.edit = false
        })
        .catch(error => {
          this.$toast.warning(`Failed to save goal: ${error}. Please try again.`, {
            position: 'top',
            duration: 5000,
            queue: false
          })
        })
    },
    changeWeek: function (week) {
      this.$store.dispatch('healthCoach/changeVitalsWeek', { week })
      this.selectWeek = false
    },
    openInsights: function () {
      this.drawerVisible = true
    },
    formatDate: function (isoString) {
      const date = new Date(isoString)
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short'
      })
    },
    getVitalsByName: function (name) {
      return this.vitals
        .filter((ele) => ele.name === name)
        .sort((ele1, ele2) => new Date(ele1.created_at) - new Date(ele2.created_at))
    },
    lastUpdateAt: function (name) {
      const vitals = this.getVitalsByName(name)
      if (!vitals.length) return 'No data available'
      const lastVital = vitals.slice(-1)[0]
      return this.formatDate(lastVital.created_at)
    },
    systolicBloodPressure: function () {
      return this.getVitalsByName('blood_pressure').map(v => v.current_value.split('/')[0])
    },
    diastolicBloodPressure: function () {
      return this.getVitalsByName('blood_pressure').map(v => v.current_value.split('/')[1])
    },
    getDailyCustomerSteps: function () {
      customerAPI.fetchSteps(this.customer.customerId, this.programDetails.enrollmentDate, 'day').then(
        response => {
          this.$store.dispatch('healthCoach/setDailyCustomerSteps', {data: response.data})
        }
      )
    },
    getWeeklyCustomerSteps: function () {
      customerAPI.fetchSteps(this.customer.customerId, this.programDetails.enrollmentDate, 'week').then(
        response => {
          this.$store.dispatch('healthCoach/setWeeklyCustomerSteps', {data: response.data})
        }
      )
    },
    stepsLastUpdateAt: function (unit) {
      if (unit === 'day') {
        if (this.dailyStepsData === undefined || this.dailyStepsData.length === 0) {
          return 'No data available'
        }
        return this.formatDate(this.dailyStepsData.slice(-1)[0].date)
      } else {
        if (this.weeklyStepsData === undefined || this.weeklyStepsData.length === 0) {
          return 'No data available'
        }
        return this.formatDate(this.weeklyStepsData.slice(-1)[0].start_date)
      }
    },
    getTimelineAndProgress: function () {
      healthCoach.getTimelineAndProgress(this.customer.customerId).then(
        response => {
          this.$store.dispatch('healthCoach/setTimelineAndProgress', {data: response.data})
        }
      )
    },
    getIcon: function (status) {
      if (status === 'received' || status === 'completed') {
        return require('../../assets/tick_green_outline.svg')
      } else if (status === 'scheduled' || status === 'in_progress') {
        return require('../../assets/orange_ring.svg')
      }
    },
    getActivityDetails: function (activity) {
      let type = ''
      console.log(activity.cta_text)
      if (activity.cta_text === 'View reports') {
        type = 'reports'
      } else if (activity.cta_text === 'View summary') {
        type = 'summary'
      }

      healthCoach.getActivityDetails(this.customer.details.id, activity.activity_id, type).then(
        response => {
          if (type === 'reports') {
            this.reportsData = response.data
            this.showTests = true
          } else if (type === 'summary') {
            this.$set(this.summaryData, activity.activity_id, response.data.summary)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
  ::-webkit-scrollbar {
    width: 7px;
    height: 45px;
  }
  ::-webkit-scrollbar-track {
    background: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background: #e5e8f0;
    border-radius: 10px;
  }
  .reports-scroll::-webkit-scrollbar-track {
    background: #f5f7f9;
  }
  .reports-scroll::-webkit-scrollbar {
    width: 4px;
    height: 33px;
  }
  .close {
    background: white;
    border: 0;
    cursor: pointer;
  }

  .right-drawer {
    position: absolute;
    top: 0;
    right: 0;
    width: 0; /* initially closed */
    height: 100vh; /* Full height to allow scrolling */
    overflow-y: auto; /* Enables scrolling */
    padding-left: 0; /* initially */
    border-left: 1px solid whitesmoke;
    background: white;
    z-index: 200;
    transition: width 0.2s ease-in-out; /* Smooth transition */
  }

  .drawer-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 0; /* initially */
    height: 100vh;
    background: #000;
    opacity: 0.3;
    z-index: 199;
    transition: opacity 0.2s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Customer/HealthCoachProgram.vue